import EditorTools from './EditorTools'

export default EditorTools
